var map = {
	"./bg.jpg": "86d5",
	"./bg1.jpg": "c5d6",
	"./dyson.png": "f258",
	"./face.jpg": "753c",
	"./nations.png": "9217",
	"./portfolio.png": "93a3",
	"./portfolio1.png": "0397"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";